try {
  localStorage.setItem('raeditor_tour_v1_done', '1');
} catch {
  /* private mode */
}

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import '@blueprintjs/core/lib/css/blueprint.css';
import '@blueprintjs/icons/lib/css/blueprint-icons.css';
import '@blueprintjs/select/lib/css/blueprint-select.css';

import './index.css';
import App from './App';
import { installApiAuthInterceptors } from './apiAuth';

installApiAuthInterceptors();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
